import Loading from '@/components/common/loading';
import { TableMobile } from '@/components/common/table/mobile';
import { PageSize, ROUTERS, TableTypes } from '@/constant';
import { memo } from 'react';

import { IDefineDocumentAreaProps } from '../define-document-area.type';
import { useLogic } from './logic';

const DefineDocumentAreaMobile = (props: IDefineDocumentAreaProps) => {
	const {
		columns,
		total,
		handlePageChange,
		isLoading,
		handleDeleteDocuments,
		navigateRegister,
		isWorkerPublicAdminRole,
	} = useLogic(props);
	return (
		<div>
			<Loading isLoading={isLoading} className="m-0" />
			<div className="bg-white min-h-[122px] md:min-h-[170px] relative">
				<TableMobile
					dataMobile={columns}
					isHideTotal
					tableClassName="!pb-[60px] relative min-h-[122px]"
					paginationClassName="!py-[3.611vw] absolute bottom-0 left-[-18px]  !w-[100vw]"
					customClassItem=""
					isShowCheckbox
					isShowDeleteButton
					labelBtnCreate="서류 등록"
					pageSize={PageSize.XXXS}
					totalRecord={total}
					onChangePagination={handlePageChange}
					handleDelete={handleDeleteDocuments}
					navigateRegister={navigateRegister}
					toDetailPathName={isWorkerPublicAdminRole ? '' : ROUTERS.DM1_03}
					tableTypes={TableTypes.DEFINE_DOCUMENT_AREA}
				/>
			</div>
		</div>
	);
};

export default memo(DefineDocumentAreaMobile);
